export const accountBalanceConfig = {
  checkoutInterval: 15000,
};
